import React from 'react'
import { CaseBtn } from './CaseListUI'

function SeeIfConflictBtn({onViewMore}) {
  return <CaseBtn onClick={onViewMore}>Check for conflict →</CaseBtn>
}

export default SeeIfConflictBtn
